import { render } from "./AddShippingMethod.vue?vue&type=template&id=1f380da2"
import script from "./AddShippingMethod.vue?vue&type=script&lang=js"
export * from "./AddShippingMethod.vue?vue&type=script&lang=js"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__